import React, { Component } from "react";
// import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { getUserForAuth } from "../../../../actions/authAction";
import { openModal } from "../../../../actions/modalAction";
import NavMobile from "./NavMobile";
import NavDesktop from "./NavDesktop";

// import {  
//   //Button, 
//   // Image,
//  // Modal,
//   Icon,
//   } from "semantic-ui-react";

class Navbar extends Component {
  componentDidMount(){
    if (!this.props.auth.userA) {
      this.props.getUserForAuth();
    }
  }

  render() {
    
    


    const authLinks = (
      <div>      
      <NavMobile  
      openModal={this.props.openModal}
      userA={this.props.userA}
      />
      <NavDesktop
      openModal={this.props.openModal}
      userA={this.props.userA} 
      />
        
</div>
 );
    return (
      <div>
        {
          authLinks
        }
      </div>
    );
  }
}
//@@@@@@@@@@@@@@@@@



const mapStateToProps = state => ({
  state,
  auth: state.auth,
  visible: state.auth.visible,
  visibleBB: state.auth.visibleBB,
  userA: state.auth.userA,
});

export default connect(
  mapStateToProps,
  { openModal, getUserForAuth}
)(Navbar);
